import React, { useEffect } from 'react';
import Icon from './AppIcon';
import { ModalShell } from './ui/ModalFrame';
import { MODAL_LAYER } from '../constants/modalLayers';

const LegalModal = ({ open, title, onClose, children }) => {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <ModalShell
      backdropPadding="none"
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-background rounded-xl w-full max-w-3xl max-h-[80vh] flex flex-col shadow-lg"
    >
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h2 className="text-lg font-semibold">{title}</h2>
        <button onClick={onClose} aria-label="Fechar">
          <Icon name="X" size={20} />
        </button>
      </div>

      <div className="p-6 overflow-y-auto text-sm leading-relaxed space-y-4">
        {children}
      </div>
    </ModalShell>
  );
};

export default LegalModal;
